
import { Component, Vue } from 'vue-property-decorator'
import { apiInventoryOverview, apiInventoryPurchaseLists, apiInventoryStockLists } from '@/api/channel/inventory'
@Component({})
export default class InventoryOverview extends Vue {
    overview: any = { goods_total: 0, goods_on_sale: 0, stock_total: 0, stock_amount: '0.00', warning_count: 0, soldout_count: 0, today_out_count: 0, today_in_count: 0 }
    recentPurchase: any[] = []
    warningGoods: any[] = []
    loading = false
    getOverview() { this.loading = true; apiInventoryOverview().then((res: any) => { this.overview = res || this.overview }).catch(() => {}).finally(() => { this.loading = false }) }
    getRecentPurchase() { apiInventoryPurchaseLists({ page_no: 1, page_size: 5 }).then((res: any) => { this.recentPurchase = res?.lists || [] }).catch(() => {}) }
    getWarningGoods() { apiInventoryStockLists({ page_no: 1, page_size: 5, stock_type: 'warning' }).then((res: any) => { this.warningGoods = res?.lists || [] }).catch(() => {}) }
    created() { this.getOverview(); this.getRecentPurchase(); this.getWarningGoods() }
}
